// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-title img {
    width: 100%;
}

a {
    color: #DA512D;
    text-decoration: none;
}

.company-title p {
    margin: 0;
}

.company-title .phone {
    color: #DA512D;
}

.logoPreview {
    width: 180px;
    height: 180px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

.logoPreview img {
    width: inherit;
    height: auto;
}

.logoFileBtn {
    position: relative;
    bottom: 15px;
    color: #98bcd5;
    font-size: 16px;
}

.mat-form-field {
    width: 100%;
}

form small.error {
    position: relative;
    top: -24px;
}

.custom-file-label {
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
    padding-right: 110px;
    text-overflow: ellipsis;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBhbnktZGV0YWlsLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxjQUFjO0lBQ2QscUJBQXFCO0FBQ3pCOztBQUVBO0lBQ0ksU0FBUztBQUNiOztBQUVBO0lBQ0ksY0FBYztBQUNsQjs7QUFFQTtJQUNJLFlBQVk7SUFDWixhQUFhO0lBQ2Isc0JBQXNCO0lBQ3RCLGtCQUFrQjtJQUNsQixtQkFBbUI7SUFDbkIsc0JBQXNCO0lBQ3RCLGtCQUFrQjtBQUN0Qjs7QUFFQTtJQUNJLGNBQWM7SUFDZCxZQUFZO0FBQ2hCOztBQUVBO0lBQ0ksa0JBQWtCO0lBQ2xCLFlBQVk7SUFDWixjQUFjO0lBQ2QsZUFBZTtBQUNuQjs7QUFFQTtJQUNJLFdBQVc7QUFDZjs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixVQUFVO0FBQ2Q7O0FBRUE7SUFDSSxtQkFBbUI7SUFDbkIsZ0JBQWdCO0lBQ2hCLHFCQUFxQjtJQUNyQixvQkFBb0I7SUFDcEIsdUJBQXVCO0FBQzNCIiwiZmlsZSI6ImNvbXBhbnktZGV0YWlsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuY29tcGFueS10aXRsZSBpbWcge1xuICAgIHdpZHRoOiAxMDAlO1xufVxuXG5hIHtcbiAgICBjb2xvcjogI0RBNTEyRDtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG59XG5cbi5jb21wYW55LXRpdGxlIHAge1xuICAgIG1hcmdpbjogMDtcbn1cblxuLmNvbXBhbnktdGl0bGUgLnBob25lIHtcbiAgICBjb2xvcjogI0RBNTEyRDtcbn1cblxuLmxvZ29QcmV2aWV3IHtcbiAgICB3aWR0aDogMTgwcHg7XG4gICAgaGVpZ2h0OiAxODBweDtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjY2NjO1xuICAgIGJvcmRlci1yYWRpdXM6IDVweDtcbiAgICBkaXNwbGF5OiB0YWJsZS1jZWxsO1xuICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4ubG9nb1ByZXZpZXcgaW1nIHtcbiAgICB3aWR0aDogaW5oZXJpdDtcbiAgICBoZWlnaHQ6IGF1dG87XG59XG5cbi5sb2dvRmlsZUJ0biB7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIGJvdHRvbTogMTVweDtcbiAgICBjb2xvcjogIzk4YmNkNTtcbiAgICBmb250LXNpemU6IDE2cHg7XG59XG5cbi5tYXQtZm9ybS1maWVsZCB7XG4gICAgd2lkdGg6IDEwMCU7XG59XG5cbmZvcm0gc21hbGwuZXJyb3Ige1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICB0b3A6IC0yNHB4O1xufVxuXG4uY3VzdG9tLWZpbGUtbGFiZWwge1xuICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgcGFkZGluZy1yaWdodDogMTEwcHg7XG4gICAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/secure/company-detail/company-detail.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;AAC3B;AACA,o2DAAo2D","sourcesContent":[".company-title img {\n    width: 100%;\n}\n\na {\n    color: #DA512D;\n    text-decoration: none;\n}\n\n.company-title p {\n    margin: 0;\n}\n\n.company-title .phone {\n    color: #DA512D;\n}\n\n.logoPreview {\n    width: 180px;\n    height: 180px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n\n.logoPreview img {\n    width: inherit;\n    height: auto;\n}\n\n.logoFileBtn {\n    position: relative;\n    bottom: 15px;\n    color: #98bcd5;\n    font-size: 16px;\n}\n\n.mat-form-field {\n    width: 100%;\n}\n\nform small.error {\n    position: relative;\n    top: -24px;\n}\n\n.custom-file-label {\n    white-space: nowrap;\n    overflow: hidden;\n    display: inline-block;\n    padding-right: 110px;\n    text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
